export const Settings = {
    DomainServiceUrl: 'https://domain.bloyal.io',
    ConfigStorageName: "myrewards1",
    ServiceUrls: {
        // LoyaltyEngineApiUrl: 'http://localhost:49653',
        // WebSnippetsApiUrl: 'http://localhost:55253'
    }
}